/** Firestore index / precondition errors (gRPC code 9). */
export function isFirestoreIndexError(e: unknown): boolean {
  if (!e || typeof e !== 'object') {
    const msg = e instanceof Error ? e.message : String(e);
    return /requires an index|FAILED_PRECONDITION|failed-precondition/i.test(msg);
  }
  const err = e as { code?: number | string; message?: string };
  if (err.code === 9 || err.code === 'failed-precondition') return true;
  const msg = err.message ?? (e instanceof Error ? e.message : String(e));
  return /requires an index|FAILED_PRECONDITION|failed-precondition/i.test(msg);
}

export const FIRESTORE_INDEX_MESSAGE = 'Firestore index building; retry shortly';
